import styles from "./PersonalDataSecurityPolicyPage.module.css";

const PersonalDataSecurityPolicyPage = () => {
  return (
    <div className={styles.container}>
      <h2>ΠΟΛΙΤΙΚΗ ΑΣΦΑΛΕΙΑΣ ΠΡΟΣΩΠΙΚΩΝ ΔΕΔΟΜΕΝΩΝ</h2>

      <p>
        Η εταιρεία THE RECORDS HUB S.A. εφαρμόζει Σύστημα για την Ασφάλεια των
        Προσωπικών Δεδομένων σύμφωνα με το διεθνές πρότυπο ISO 27701:2019. Η
        Διοίκηση της εταιρείας αναγνωρίζει τους κινδύνους που υπάρχουν για την
        ασφάλεια των πληροφοριών και των προσωπικών δεδομένων στο πλαίσιο των
        δραστηριοτήτων της και δεσμεύεται να παρέχει όλους τους απαιτούμενους
        πόρους ώστε να εφαρμόζεται ένα Σύστημα για την Ασφάλεια των Προσωπικών
        Δεδομένων.
      </p>

      <p>
        Το σύστημα Προστασίας Προσωπικών Δεδομένων καλύπτει τις παρακάτω
        υπηρεσίες της εταιρείας:
      </p>
      <ul>
        <li>
          ΠΡΟΣΤΑΣΙΑ ΠΡΟΣΩΠΙΚΩΝ ΔΕΔΟΜΕΝΩΝ ΩΣ ΥΠΕΥΘΥΝΟΣ ΕΠΕΞΕΡΓΑΣΙΑΣ ΓΙΑ ΤΙΣ
          ΛΕΙΤΟΥΡΓΙΕΣ ΤΗΣ ΕΤΑΙΡΕΙΑΣ ΚΑΙ ΠΡΟΣΤΑΣΙΑ ΠΡΟΣΩΠΙΚΩΝ ΔΕΔΟΜΕΝΩΝ ΩΣ
          ΕΚΤΕΛΩΝ ΤΗΝ ΕΠΕΞΕΡΓΑΣΙΑ ΓΙΑ ΤΗ ΠΑΡΟΧΗ ΥΠΗΡΕΣΙΩΝ ΓΙΑ ΤΗΝ ΑΣΦΑΛΗ
          ΨΗΦΙΟΠΟΙΗΣΗ, ΑΣΦΑΛΗ ΦΥΛΑΞΗ, ΑΣΦΑΛΗ ΚΑΤΑΣΤΡΟΦΗ ΚΑΙ ΑΣΦΑΛΗ ΔΙΑΧΕΙΡΙΣΗ
          ΑΡΧΕΙΩΝ ΠΕΛΑΤΩΝ ΤΗΣ ΕΤΑΙΡΕΙΑΣ ΣΕ ΕΝΤΥΠΗ Η/ΚΑΙ ΗΛΕΚΤΡΟΝΙΚΗ ΜΟΡΦΗ,
          ΠΑΡΟΧΗ ΣΥΜΒΟΥΛΕΥΤΙΚΩΝ ΥΠΗΡΕΣΙΩΝ ΓΙΑ ΤΗΝ ΑΣΦΑΛΗ ΔΙΑΧΕΙΡΙΣΗ ΑΡΧΕΙΩΝ,
          ΣΥΜΒΟΥΛΕΥΤΙΚΕΣ ΥΠΗΡΕΣΙΕΣ GDPR/DPO.
        </li>
      </ul>

      <p>Στρατηγικοί στόχοι της εταιρείας είναι:</p>
      <ul>
        <li>
          Η διασφάλιση των προσωπικών δεδομένων των υπαλλήλων και πελατών.
        </li>
        <li>
          Έλεγχος της εφαρμογής του Συστήματος για την Ασφάλεια των Προσωπικών
          Δεδομένων μέσω του ορισμένου Data Protection Officer.
        </li>
        <li>
          Η ανάπτυξη και η εφαρμογή πολιτικών και διαδικασιών ώστε να
          διασφαλίζεται η ασφάλεια των προσωπικών δεδομένων, η εμπιστευτικότητα,
          ακεραιότητα και η διαθεσιμότητα των πληροφοριών και των εγκαταστάσεων
          που χρησιμοποιούνται για τη διαχείριση των πληροφοριών.
        </li>
        <li>
          Η συμμόρφωση με τις κανονιστικές και νομικές υποχρεώσεις και τις
          υποχρεώσεις που προέρχονται από τις συμφωνίες με τους πελάτες.
        </li>
        <li>
          Η συστηματική αποτίμηση και αξιολόγηση των κινδύνων που αφορούν την
          προστασία των Προσωπικών Δεδομένων.
        </li>
        <li>
          Η συνεχής ενημέρωση και εκπαίδευση της διοίκησης και του προσωπικού σε
          θέματα προστασίας των προσωπικών Δεδομένων.
        </li>
        <li>
          Ο αποτελεσματικός έλεγχος των διακινούμενων πληροφοριών και δεδομένων.
        </li>
        <li>
          Η προστασία των συμφερόντων της Εταιρείας και όσων συναλλάσσονται με
          αυτήν.
        </li>
        <li>
          Η ενθάρρυνση της εσωτερικής και εξωτερικής επικοινωνίας σχετικά με τα
          θέματα Ασφάλειας των Προσωπικών Δεδομένων.
        </li>
      </ul>

      <p>
        Η Εταιρεία δεσμεύεται για την συνεχή προσπάθεια βελτίωσης του Συστήματος
        Ασφάλειας Προσωπικών Δεδομένων έτσι ώστε να μπορεί να προσφέρει υψηλά
        επίπεδα ασφάλειας στους πελάτες και συνεργάτες της.
      </p>
    </div>
  );
};

export default PersonalDataSecurityPolicyPage;
